export function formatPercent(value: number, opts: { signed?: boolean; digits?: number } = {}): string {
  if (!Number.isFinite(value)) return '—';
  const digits = opts.digits ?? 1;
  const sign = opts.signed && value > 0 ? '+' : '';
  return `${sign}${value.toFixed(digits)}%`;
}
